import { CSSProperties } from 'react'

export const getDropZoneStyle = (isDragging: boolean): CSSProperties => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  height: '300px',
  border: `2px dashed ${isDragging ? '#c0392b' : '#ddd'}`,
  borderRadius: '12px',
  backgroundColor: isDragging ? '#fdf0f0' : '#fafafa',
  cursor: 'pointer',
  transition: 'all 0.2s ease',
})

export const dropZoneStyles: Record<string, CSSProperties> = {
  icon: {
    fontSize: '48px',
    marginBottom: '16px',
  },
  title: {
    fontSize: '18px',
    fontWeight: 600,
    color: '#333',
    marginBottom: '8px',
  },
  subtitle: {
    fontSize: '14px',
    color: '#c0392b',
    marginBottom: '16px',
    fontWeight: 500,
  },
  formats: {
    fontSize: '12px',
    color: '#999',
  },
}
